var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/calendar-list-mobile-view/calendar-list-mobile-view.html';
var html = "<div class=event-tab-content> <div ng-repeat=\"day in $ctrl.details | orderBy:'day'\" class=month-days> <div class=text-right> <div class=days-mob> <h3>{{day.day}}</h3> <p>{{day.name}}</p> </div> </div> <div class=event-holiday-details> <div ng-repeat=\"dayDetail in day.details\" class=event-list-style> <div ng-include=$ctrl.templateUrl class=events-list-mobile ng-click=$ctrl._onEventClick(dayDetail)> </div> </div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/calendar-list-mobile-view/calendar-list-mobile-view.html
// module id = 904
// module chunks = 0